import type { ChaoServiceDef } from "@/services/chaoDeObra";

export interface EapCatalogSection {
  group: ChaoServiceDef;
  /** Filhas diretas da conta mãe (ex.: 01.000.000.001). */
  items: ChaoServiceDef[];
  /** Subcontas mãe com suas filhas (ex.: 05.001 — Esquadrias). */
  subgroups: { group: ChaoServiceDef; items: ChaoServiceDef[] }[];
}

export function buildEapCatalogSections(catalog: ChaoServiceDef[]): EapCatalogSection[] {
  if (!catalog?.length) return [];

  const hasHierarchy = catalog.some((s) => s.isGroup === true);
  if (!hasHierarchy) {
    return catalog.map((svc) => ({
      group: { ...svc, isGroup: true, weight: 0 },
      items: [],
      subgroups: [],
    }));
  }

  const topGroups = catalog.filter((s) => s.isGroup && !s.parentId);
  return topGroups.map((group) => {
    const subgroups = catalog
      .filter((s) => s.isGroup && s.parentId === group.id)
      .map((sg) => ({
        group: sg,
        items: catalog.filter((s) => !s.isGroup && s.parentId === sg.id),
      }));
    const items = catalog.filter(
      (s) => !s.isGroup && s.parentId === group.id
    );
    return { group, items, subgroups };
  });
}

export function leafServices(catalog: ChaoServiceDef[]): ChaoServiceDef[] {
  return catalog.filter((s) => !s.isGroup);
}
